export default "__VITE_ASSET__xf$hrzu___"